import { Button } from "@design-lab/shared/ui";
import { ChevronRight } from "lucide-react";
import { useTab } from "@design-lab/shared/ui/layouts/state";
import { Tooltip, TooltipTrigger, TooltipContent } from "@design-lab/shared/ui/tooltip";
import { useArtwork } from "@design-lab/entities/artwork";
import { useProcessingTooltip } from "@design-lab/shared/hooks/useProcessingTooltip";

type NextButtonProps = {
  className?: string;
};

export function NextButton(props: NextButtonProps) {
  const { className } = props;
  const { tab, nextTab, isValid, canGoNext, next } = useTab();

  const { front, back } = useArtwork();

  const frontHasLoading = front.state.hasTag("loading");
  const backHasLoading = back.state.hasTag("loading");

  const shouldShowTooltip = (frontHasLoading || backHasLoading) && tab === "upload";

  const { showTooltip, dismissTooltip } = useProcessingTooltip(shouldShowTooltip);

  if (!canGoNext || !nextTab) return null;

  return (
    <Tooltip open={showTooltip}>
      <TooltipTrigger asChild data-testid="next-button-tooltip-trigger">
        <Button
          data-testid="next-button"
          variant="destructive"
          className={className ?? ""}
          isDisabled={!isValid}
          onPress={next}
        >
          Next: {nextTab.mobileTitle} <ChevronRight />
        </Button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        align="end"
        onClose={dismissTooltip}
        className="bg-blue-700 p-4"
        arrowClassName="bg-blue-700 fill-blue-700"
      >
        <p className="text-sm">
          While the image is being processed continue to add colors and more products.
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
